import * as React from 'react';
import { FC, useState } from 'react';
import type { Filters, UpdateFilters } from './useFilters';

const SEARCH_TIMEOUT = 350; // ms

const Name: FC<{ updateFilters: UpdateFilters; label: string }> = ({ updateFilters, label }) => {
  const [name, setName] = useState('');
  const [loadTimeoutId, setLoadTimeoutId] = useState<number>();

  const changeValue = (v: string) => {
    if (!v.length || v.length >= 3) {
      updateFilters({ name: v });
    }
  };

  const debouncedSearch = (v: string) => {
    setName(v);
    window.clearTimeout(loadTimeoutId);
    setLoadTimeoutId(
      window.setTimeout(() => {
        changeValue(v);
      }, SEARCH_TIMEOUT)
    );
  };

  return (
    <input
      aria-label={label}
      placeholder={label}
      type="search"
      value={name}
      onChange={(e) => debouncedSearch(e.target.value)}
    />
  );
};

const Type: FC<{ filters: Filters; updateFilters: UpdateFilters; types: [string, string][] }> = ({
  filters,
  updateFilters,
  types,
}) => (
  <select name="type-filters" onChange={(e) => updateFilters({ type: e.target.value })} value={filters.type} required>
    {types.map((type) => (
      <option key={type[0]} value={type[0] === 'all_games' ? '' : type[0]}>
        {type[1]}
      </option>
    ))}
  </select>
);

const FiltersComponent: FC<{
  filters: Filters;
  updateFilters: UpdateFilters;
  locales: Record<string, string>;
  types: [string, string][];
}> = ({ filters, updateFilters, locales, types }) => (
  <div className="rs-row">
    <div className="rs-small-6">
      <Name updateFilters={updateFilters} label={locales.search} />
    </div>
    <div className="rs-small-6">
      <Type filters={filters} updateFilters={updateFilters} types={types} />
    </div>
  </div>
);

export default FiltersComponent;
